module.exports = __webpack_public_path__ + "img/Group 6825@2x.ca6b2ec2.png";